<template>
  <div v-show="false">
    <div>
      <AddToCart
        :id="item.sku"
        v-for="(item, index) in productInfo"
        :key="index"
      />
    </div>

    <AddToCart id="142997" />
  </div>
</template>

<script>
import { AddToCart } from "../index.js";
import data from "~/data/machine.js";

export default {
  name: "renderForCartButton",
  components: { AddToCart },
  computed: {
    productInfo() {
      return data.machine;
    },
  },
};
</script>
